export const locale = {
  lang: 'en-CA',
  data: {
    APP: {
      TITLE: 'Caterer Manager',
      LOGO: 'fuse-en.png',
    },
    APP_UPDATE: {
      TITLE: 'New version available',
      MESSAGE: 'Tap here to update. Close to be reminded later.',
      BUSY_TITLE: 'Update postponed',
      BUSY_MESSAGE:
        'Save or close your work in progress, then tap the notice again.',
      TOOLTIP: 'Update to the latest version',
    },
    PRINT_ERROR: {
      TITLE: 'Unable to print',
      MESSAGE:
        'The document to print could not be retrieved (invalid download link). Please try again, and contact support if the problem persists.',
    },
    MAIL_PROCESS: {
      SENT: 'Email sent',
    },
    GOOGLE_DRIVE_PROCESS: {
      QUEUED:
        'The report will be dropped into Google Drive as soon as it is generated.',
      SUCCESS_TITLE: 'Report saved to Google Drive',
      SUCCESS_OPEN: 'Open in Google Drive',
      FAILED_TITLE: 'Could not send to Google Drive',
      FAILED_MESSAGE:
        'The report was generated and downloaded, but the Google Drive copy failed.',
      ERR_GDD0003:
        'No active Google Drive account — reconnect it under Settings → Integrations → Google Drive.',
      ERR_GDD0005: 'This report format cannot be sent to Google Drive.',
      ERR_GDD0007: 'The file is too large to be converted into a Google Sheet.',
      ERR_GDD0008:
        'Google Drive did not accept the file. You can retry from Settings → Integrations → Google Drive.',
      ERR_GDD0009:
        'The destination folder could not be created in Google Drive.',
      ERR_GDD0010:
        'The Google Drive module is not active for your organization.',
      ERR_GDD0013:
        'The configured target folder is not accessible to Gestion-Traiteur. Clear it under Settings → Integrations → Google Drive.',
      TOO_LARGE:
        'Too much data for {{target}}: the file is {{size}} MB, the limit is {{max}} MB. Narrow the period or the columns.',
      ERR_GDD0015:
        'The file exceeds the size accepted for Google Drive. Narrow the period or the columns.',
      ERR_GDD0016:
        'The report produced no document (empty stack): nothing to send to Google Drive.',
    },
    ONEDRIVE_PROCESS: {
      QUEUED:
        'The report will be dropped into OneDrive as soon as it is generated.',
      SUCCESS_TITLE: 'Report saved to OneDrive',
      SUCCESS_OPEN: 'Open in OneDrive',
      FAILED_TITLE: 'Could not send to OneDrive',
      FAILED_MESSAGE:
        'The report was generated and downloaded, but the OneDrive copy failed.',
      ERR_ODR0003:
        'No active Microsoft account — reconnect it under Settings → Integrations → OneDrive.',
      ERR_ODR0005: 'This report format cannot be sent to OneDrive.',
      ERR_ODR0006:
        'The temporary copy of the report expired; run the report again.',
      ERR_ODR0008:
        'OneDrive did not accept the file. You can retry from Settings → Integrations → OneDrive.',
      ERR_ODR0009: 'The destination folder could not be created in OneDrive.',
      ERR_ODR0010: 'The OneDrive module is not active for your organization.',
      ERR_ODR0012:
        'Microsoft revoked the access — reconnect the account under Settings → Integrations → OneDrive.',
      ERR_ODR0014:
        'The linked Microsoft account did not grant OneDrive access — click "Enable OneDrive" under Settings → Integrations → OneDrive.',
      ERR_ODR0015:
        'The OneDrive of this account is not initialized yet: open onedrive.live.com once with this account, then try again.',
      TOO_LARGE:
        'Too much data for {{target}}: the file is {{size}} MB, the limit is {{max}} MB. Narrow the period or the columns.',
      ERR_ODR0016:
        'The file exceeds the size accepted for OneDrive. Narrow the period or the columns.',
      ERR_ODR0017:
        'The report produced no document (empty stack): nothing to send to OneDrive.',
    },
    CHAT: {
      PLACEHOLDER: 'Type a message...',
      EMPTY: 'Hello! How can I help you today?',
      ERROR: 'Sorry, I encountered an error. Please try again.',
    },
    GENERIC: {
      ORGANIZATIONS: 'Organizations',
      SELECT_CATERER: 'Select a caterer',
      INGREDIENTS: 'Ingredients',
      CHOOSE_DATE: 'Select a date',
      START_TIME: 'Time (Start)',
      END_TIME: 'Time (End)',
      START_DATE: 'Date (Start)',
      END_DATE: 'Date (End)',
      CREATED_AT: 'Created at',
      EVENT_NAME: 'Event name',
      GUEST_COUNT_DT: 'Guest count',
      EVENT_LOGISTIC_STATUS: 'Logistic status',
      SELECT_RESPONSIBLE_EMPLOYEE: 'Advisor',
      PROJECT_DEPOSIT: 'Project deposit',
      REPORT_MODE_NORMAL: 'Period',
      REPORT_MODE_DATE_NOW: 'Until now',
      NEXT: 'Next',
      BACK: 'Previous',
      PREVIOUS: 'Previous',
      YES: 'Yes',
      NO: 'No',
      ON: 'on',
      OFF: 'off',
      OK: 'OK',
      CLEAR: 'Clear',
      ADD: 'Add',
      CONFIRM: 'Confirm',
      CONFIRMATION: 'Confirmation',
      CANCEL: 'Cancel',
      SUBMIT: 'Submit',
      LOGIN: 'Log in',
      LOGOUT: 'Log out',
      BILLING: 'Billing',
      PRICE_PER_GUEST: 'Price per guest',
      FOOD: 'Food',
      DRINK: 'Drink',
      CHARGED: 'Charged',
      INCLUDED: 'Included',
      AND: 'and',
      GENDER: {
        GENDER: 'Gender',
        FEMALE: 'Female',
        MALE: 'Male',
        MR: 'Mr.',
        MS: 'Ms.',
      },
      MISS: 'Miss',
      MS: 'Mis',
      MRS: 'Mrs',
      MR: 'Mr',
      'fr-CA': 'French',
      'en-CA': 'English',
      'mobile-fr-CA': 'Image for mobile French',
      'mobile-en-CA': 'Image for mobile English',
      APPLICATION: 'Application',
      SUPPORT: 'Support',
      LANGUAGE: 'Language',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      ROLE: 'Role',
      GOD: 'God',
      ROLE_OWNER: 'Owner',
      ROLE_ADMIN: 'Administrator',
      ROLE_EMPLOYEE: 'Employee',
      ROLE_SALE: 'Sales',
      ROLE_ACCOUNTANT: 'Accountant',
      ROLE_HR: 'Human Resources',
      ROLE_TEAM_LEAD: 'Supervisor',
      ADMIN: 'Admin',
      KITCHEN: 'Kitchen',
      SALE: 'Sale',
      SERVICE: 'Service',
      OTHER: 'Other',
      TAX: 'Tax',
      SELECT_TAX: 'Select tax',
      CREATE: 'Create',
      DELETE_CONFIRM: 'Are you sure you want to delete this item?',
      CANCEL_CONFIRM: 'Are you sure you want to cancel this item?',
      CANCEL_INVITE_CONFIRM: 'Are you sure you want to cancel the invitation?',
      DELETE_CONFIRM_S: 'Are you sure you want to delete these items?',
      DELETE_SUCCESS: 'Deleted successfully',

      API_CALL_SUCCESS: {
        SAVE_SUCCESS: 'Saved successfully',
        CREATE_SUCCESS: 'Created successfully',
        DELETE_SUCCESS: 'Deleted successfully',
        CREATE_CLIENT: 'Client created successfully',
        CREATE_PRODUCT: 'Product created successfully',
        CREATE_MATERIAL: 'Equipment created successfully',
        CREATE_ENTERPRISE: 'Enterprise created successfully',
        DELETE_EMPLOYEE: 'Employee deleted successfully',
        INVITE: 'Invitation successfully resent',
        CANCEL_INVITE: 'Invitation successfully cancel',
        CREATE_EMPLOYEE: 'Employee created successfully',
        CREATE_ROOM: 'Room created successfully',
        CREATE_PLACE: 'Place created successfully',
        CREATE_SECTOR: 'Sector successfully created',
        CREATE_SHOP: 'Online shop created successfully',
      },
      ERROR: 'Error',
      ERROR_DIALOG_TITLE: 'Error',
      ERROR_DIALOG_422_TITLE: 'Warning - Validation error',
      ERROR_DIALOG_422_MESSAGE: 'The data provided was invalid.',
      ERROR_DIALOG_TITLE_422: 'Validation',
      ERRORS: {
        GENERIC: 'Unable to process the request. Please try again',
        GENERIC_ERROR: 'An unknown error has occurred.',
        API_CALL_STATUS_NOT_FOUND:
          'Unable to process request not found. Please try again',
        CREATE_CLIENT: 'An error occurred while creating the client',
        DELETE_EMPLOYEE: 'An error occurred while deleting the employee',
        INVITE: 'An error occurred while sending the invitation.',
        CREATE_EMPLOYEE: 'An error occurred while creating the employee',
      },
      TERMS_CONDITIONS: 'terms and conditions',
      SEARCH: 'Search',
      FILTERING_PLACEHOLDER: 'filter',
      NAME: 'Name',
      CLIENT_NAME: 'Client name',
      NAME_INTERNAL: 'Internal name',
      PRICE: 'Price',
      RATE: 'Rate',
      AMOUNT: 'Amount',
      ACTIVE: 'Active',
      CATEGORY: 'Category',
      QUANTITY: 'Quantity',
      PHONE: 'Telephone',
      PHONE_NUMBER: 'Telephone number',
      MOBILE: 'Mobile',
      OFFICE_PHONE: 'Office phone',
      OFFICE_EXT: 'Ext',
      SAVE: 'Save',
      DELETE: 'Delete',
      EDIT: 'Edit',
      EDIT_STOP: 'Stop Edit',
      NOT_EDITABLE: 'This item cannot be edited',
      SEND: 'Send',
      ID: 'ID',
      TOTAL: 'Total',
      SUBTOTAL: 'Subtotal',
      PAYMENT: 'Payment',
      PAYMENT_MODE: 'Payment Mode',
      STATUS: 'Status',
      TYPE: 'Type',
      DATE: 'Date',
      TIME: 'Time',
      FROM: 'from',
      TO: 'to',
      TO2: 'to',
      SUBJECT: 'Subject',
      START: 'Start',
      END: 'End',
      UNTIL: 'Until',
      DATE_START: 'Start date',
      DATE_END: 'End date',
      TIME_START: 'Time start',
      TIME_END: 'Time end',
      SEE_ON_GOOGLE_MAP: 'See on Google Map',
      CONTENT: 'Content',
      STORAGE_ROOM: 'Local d’entreposage',
      FILTER: 'Filter...',
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      CONFIRMED: 'Confirmed',
      SELECT_LANGUAGE: 'Select your language',
      EMPLOYEES: 'Employees',
      EMPLOYEE: 'Employee',
      USER: 'User',
      CLIENTS: 'Clients',
      CLIENTS_ENTERPRISE: 'Clients and enterprises',
      CLIENT: 'Client',
      WEB_CLIENT: 'Web client',
      ENTERPRISES: 'Enterprises',
      ENTERPRISE: 'Enterprise',
      ORGANIZATION: 'Organization',
      VENUE: 'Place',
      VENUES: 'Places',
      VENUES_TAB: 'Place and delivery',
      ROOM: 'Room',
      ROOMS: 'Rooms',
      ROOM_WEB: 'WEB order room',
      ALCOHOL_PERMIT_LOCAL: 'Event local',
      SECTOR: 'Sector',
      PRODUCTS: 'Products',
      FOOD_DRINK: 'Foods & drinks',
      PRODUCT: 'Product',
      MATERIALS: 'Equipments',
      MATERIAL: 'Equipment',
      DASHBOARD: 'Dashboard',
      OPERATIONS: 'Dashboard',
      DASHBOARD_DETAILED_JUL: 'Detailed Dashboard - Jul',
      ROOM_MANAGEMENT: 'Room management',
      DELIVERY: 'Delivery',

      EVENT: 'Event',
      EVENTS: 'Events',
      NO_RESULTS: 'No results',
      TABLE_ITEMS_PER_PAGE: 'Items per page',
      TABLE_NEXT_PAGE: 'Next page',
      TABLE_PREVIOUS_PAGE: 'Previous page',
      TABLE_FIRST_PAGE: 'First page',
      TABLE_LAST_PAGE: 'Last page',
      INFORMATION: 'Information',
      GENERAL_INFORMATION: 'General information',
      PAGE_FORM_GARD:
        'You have unsaved changes! If you leave, your changes will be lost.',
      NONE: 'None',
      PRINT: 'Print',
      PRINT_ORDER: 'Print purchase order',
      DOWNLOAD_ORDER: 'Download purchase order',
      PRINT_PROPOSAL: 'Print the proposal',
      DOWNLOAD_PROPOSAL: 'Download proposal',
      PRINT_DOWNLOAD_PROPOSAL: 'Download/print proposal',
      SEND_PROPOSAL: 'Send proposal',
      PREVIEW: 'Preview',
      OPEN_NEW_TAB: 'Open in new tab',
      OPEN_SAME_TAB: 'Open in same tab',
      EDIT_COMBO_ACTION:
        'Change the order of items or click the + button to add/remove items',
      OPEN_CLIENT: 'Open client page',
      OPEN_ENTERPRISE: 'Open enterprise page',
      ORDERS: 'Orders',
      ORDER: 'Order',
      PROPOSAL: 'Proposal',
      INVOICE: 'Invoice',
      WRAPPING: 'Packaging',
      CONTACT: 'Contact',
      ADDRESS: 'Address',
      ADDRESSES: 'Addresses',
      NOTE: 'Note',
      NOTES: 'Notes',
      CLIENT_NOTE: 'Client note',
      SERVICE_DATE: 'Service date',
      DAY_NOTES: 'Note of the Day',
      CALENDAR: 'Calendar',
      TODAY: 'Today',
      MIN_TODAY: 'Tod.',
      MIN_DAY: 'D',
      MIN_WEEK: 'W',
      MIN_MONTH: 'M',
      DAY: 'Day',
      WEEK: 'Week',
      MONTH: 'Month',
      THIS_WEEK: 'This week',
      NEXT_2_WEEK: 'Next 2 weeks',
      THIS_MONTH: 'This month',
      NEXT_MONTH: 'Next month',
      PREVIOUS_WEEK: 'Previous week',
      PREVIOUS_MONTH: 'Previous month',
      LAST_12_MONTHS: 'Last 12 months',
      DOWNLOAD: 'Download',
      DOWNLOAD_PDF: 'Download PDF',
      DOWNLOAD_VCARD: 'Download VCard',
      DOWNLOAD_XLS: 'Download in Excel format',
      SEND_TO_GOOGLE_DRIVE: 'Send to Google Drive',
      SEND_TO_ONEDRIVE: 'Send to OneDrive',
      REFRESH: 'Refresh',
      DOWNLOAD_CSV: 'Download in CSV format',
      WEBSITE: 'Website',
      BRANCH: 'Branch',
      GENERAL: 'General',
      GENERALS: 'General',
      REPORT: 'Report',
      CLICK_TO_COPY: 'Click to copy',
      GOOGLE_ADDRESS_PLACEHOLDER: 'Search for an address',
      MEDIA: 'Media',
      ALLERGENS: 'Allergens',
      NUMBER: 'Number',
      FACEBOOK: 'Facebook',
      LINKEDIN: 'LinkedIn',
      TWITTER: 'Twitter',
      YOUTUBE: 'Youtube',
      INSTAGRAM: 'Instagram',
      TIKTOK: 'TikTok',
      WHATSAPP: 'WhatsApp',
      PINTEREST: 'Pinterest',
      THREADS: 'Threads',
      TELEGRAM: 'Telegram',
      DURATION: 'Duration',
      EMAIL_INVALID: 'Must be a valid email',
      INPUT_LENGTH_INVALID_MIN_2: '2 characters minimum',
      INPUT_LENGTH_INVALID_SMALL: 'Must be between 2 and 50 characters',
      INPUT_LENGTH_INVALID: 'Must be between 2 and 120 characters',
      INPUT_LENGTH_INVALID_1: 'Must be between 1 and 120 characters',
      INPUT_LENGTH_INVALID_20: 'Must be between 2 and 20 characters',
      INPUT_LENGTH_INVALID_30: 'Must be between 2 and 30 characters',
      INPUT_LENGTH_INVALID_40: 'Must be between 2 and 40 characters',
      NOTE_EDITOR_LENGTH_INVALID_2048: 'Note must not exceed 2048 characters',
      NOTE_EDITOR_LENGTH_INVALID: 'Note must not exceed 50 000 characters',
      RICH_TEXT_EDITOR_LENGTH_INVALID:
        'This text must not exceed 50 000 characters',
      TAG_LENGTH_INVALID: 'Tags must not exceed 30 characters',
      MODEL_NUMBER_INPUT_LENGTH_INVALID: 'Must be between 1 and 120 characters',
      INPUT_LENGTH_INVALID_191: 'Must be between 2 and 191 characters',
      INPUT_LONG_LENGTH_INVALID: 'Must be between 2 and 2048 characters',
      INPUT_SHORT_LENGTH_INVALID: 'Must be between 2 and 30 characters',
      INPUT_NUMBER: 'Must be a number',
      INPUT_NUMBER_0_999: 'Number must be between 0 and 999',
      INPUT_NUMBER_0_100: 'Number must be between 0 and 100 inclusive',
      INPUT_NUMBER_0_9999: 'Number must be between 0 and 9999',
      INPUT_NUMBER_0_999999: 'Number must be between 0 and 1 million',
      INPUT_NUMBER_POSTFIX_999999: ' and maximum of 1 million',
      INPUT_NUMBER_ABOVE_ZERO: 'Number must higher than zero',
      INPUT_NUMBER_POSTFIX_2_DECIMAL: ', no more than 2 decimals',
      INPUT_NUMBER_INTEGER_ONLY: 'The number must be an integer',
      INPUT_NUMBER_POSTFIX_INTEGER_ONLY: ', integer only',
      INPUT_NUMBER_MINUS_100_100: 'The number must be between -100 and 100',
      INPUT_NUMBER_NOT_ZERO: "The number can't be zero",
      DATE_DOB_INVALID:
        "The date must be between the year 1900 and today's date",
      DATE_DEFAULT_RANGE_INVALID:
        'The date must be between the year 1900 and 2099',
      DATE_TODAY_UP_RANGE_INVALID: "The date must be today's date or higher",
      DATE_TODAY_DOWN_RANGE_INVALID: "The date must be today's date or lower",
      NEW_TAG: 'Tags:',
      LEDGER_ACCOUNT: 'Ledger account',
      AVAILABLE: 'Available',
      ALCOHOLIC_PRODUCT: 'Alcoholic product',
      DATA: 'Data',
      CONFORMED_INFO_TITLE: 'Confirmed and unconfirmed product',
      // tslint:disable-next-line:max-line-length
      CONFORMED_INFO_DESCRIPTION:
        'Confirmed product: A confirmed product is a regular product approved by the Chef or Menu Producer. The cost of food and the sale price have been validated by the manager. The confirmed statement indicates that the product meets your standards and your food cost targets. \n \n \n Unconfirmed product:\n Is a product created or modified within an order or in the product section not validated by the Chef or the person responsible for the development of the menus. Ex. Last minute product, customized, adapted for a particular customer, etc. Only the Chef or Menu Developers can change the status of a product.',
      INTERNAL_NAME: 'Internal name',
      EXTERNAL_NAME: 'External name',
      SAGE: 'Sage',
      GOOGLE_CALENDER: 'Google Calendar',
      SHOP_WEB: 'Shop web',
      STRIPE: 'Stripe',
      QUICK_ORDER: 'Quick Order',
      NEW_PICKUP: 'New Pickup [Beta]',
      READ_ONLY_MODE: 'READ ONLY MODE',
      ARCHIVE_PAGE: 'Page archived',
      DELETED_PAGE: 'This item was deleted on {{date}}. Read-only view.',
      RESTORE: 'Restore',
      FEATURE_COMING_SOON: 'Feature coming soon',
      DELETED_ENTITY_ERROR:
        'This item has been deleted and cannot be modified.',
      SECTORS: 'Sectors',
      CHOOSE_SECTOR: 'Choose a sector',
      NO_SECTORS: 'No sectors created yet.',
      MATERIAL_COMBO: 'Kit',
      COLOR: 'Color',
      DAYS: {
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
        SUNDAY: 'Sunday',
      },
      ASSIGNMENTS: 'Assignments',
      ASSIGNMENT: 'Assignment',
      ALL_DAY: 'Entire day',
      LETTER_FORMAT: 'letter format',
      LEGAL_FORMAT: 'legal format',
      EXCEL_FORMAT: 'Excel format',
      NO_PERMISSIONS: 'Access denied',
      JOB_FUNCTIONS: 'Job functions',
      AVAILABLE_EDIT_MODE_ONLY: 'In edit mode only',
      PRODUCT_CATEGORY: 'Product category',
      FOOD_DRINK_CATEGORY: 'Foods & drinks category',
      PRODUCT_CATEGORY_SELECT: 'Select a category',
      MATERIAL_CATEGORY: 'Equipment category',
      MATERIAL_CATEGORY_SELECT: 'Select a category',
      DELETED_SUFFIX: 'Deleted',
      WITH_DELIVERY: 'With delivery',
      WITH_TAKEOUT: 'With takeout',
      DELIVERY_TYPE1: 'Delivery only',
      DELIVERY_TYPE2: 'Deliver and install',
      DELIVERY_TYPE3: 'With staff',
      DELIVERY_TYPE4: 'Takeout at the counter',
      RESPONSIBLE_EMPLOYEE: 'Advisor',
      FILES: 'Files',
      ATTACH_FILE: 'Attach a file',
      SELECT_IMG_RULES: 'JPG or PNG image of 10 MB maximum',
      NO_ATTACHED_FILES: 'No files',
      FILESIZE: 'File size',
      NIGHT: 'Night',
      PERCENTAGE: 'Percentage',
      ROYALTY_FOOD_BEVERAGE: 'Royalty on food & beverage',
      ROYALTY_FOOD: 'Royalty on food',
      ROYALTY_BEVERAGE: 'Royalty on beverage',
      ROYALTY_MATERIAL: 'Royalty on equipment',
      ROYALTY_SERVICE: 'Royalty on services',
      ROYALTY_DELIVERY_FEE: 'Royalty on delivery fees',
      ROYALTY_TOTAL_TAXES_INCLUDED_FEE:
        'Royalty on total amount taxes included',
      ROYALTY_SERVICE_CHARGE: 'Service charges',
      NO_ATTACHED_FILES_DROPZONE:
        'Drop a file here or click on the green + button',
      FORM_DIRTY_TIP: 'One or more required field is missing or incorrect.',
      NEW: 'New',
      RESERVATION: 'Reservation',
      BLOCKED: 'Blocked',
      OVERLAP_ERROR_MESSAGE:
        'An event cannot overlap with another for the same room',
      ATTEMPT: 'Attempt',
      EVENT_IN_PROPOSAL: 'In proposal',
      EVENT_IN_ORDER: 'In order',
      EVENT_IN_INVOICE: 'In invoice',

      RP_EVENT_IN_PROPOSAL: 'In proposal',
      RP_EVENT_IN_ORDER: 'Final',
      RP_EVENT_IN_INVOICE: 'In invoice',
      RP_ATTEMPT: 'Attempt',

      NO_END_TIME_FOR_EVENT_WITH_ROOM_INTERNAL:
        'You have selected an internal venue, please select an end time for your reservation to appear in your room management calendar',
      ROOM_STATUS: 'Room status',
      INTERNAL: 'Internal',
      PROGRAMS: 'Programs',
      DESCRIPTION: 'Description',
      MONTAGE: 'Assembly',
      GUEST: 'Guests',
      GUEST_S: 'Guest',
      GUEST_COUNT: 'Guests count',
      ESPACE: 'Space',
      TARIFS: 'Prices',
      SELECT_ROOM: 'Select room',
      SELECT: 'Select',
      GUEST_COUNT2: '# guests',
      SC_ROOM: 'Room',

      INVOICE_OPEN: 'Invoice issued',
      INVOICE_SEND: 'Invoice sent',
      INVOICE_PAID: 'Invoice paid',
      INVOICE_OVER_DUE: 'Overdue invoice',
      INVOICE_CANCEL: 'Invoice canceled',
      CLIENT_INVOICE: 'Client invoice',
      CONTRAT_BANQUET_CLIENT: 'Order by enterprise',
      CONTRAT_BANQUET_CLIENT_CT: 'Contrat banquet by enterprise',
      CREATE_PROJECT: 'Create project',
      CREATE_EVENT: 'Create event',

      EVENT_DATE: 'Event date',
      EVENT_DATE_START: 'Event start date',
      EVENT_DATE_END: 'Event end date',
      EVENT_TIME_START: 'Event start time',
      EVENT_TIME_END: 'Event end time',
      EVENT_TIME: 'Event time',
      EVENT_NUMBER: 'Event number',
      CHOOSE_A_DATE: 'Choose a date range',
      CHOOSE_A_DATE_MOBILE: 'Choose a date',
      INCLUDE_SHOW_CANCELED: 'Show cancelled congress',
      CONGRESS_NUMBER_DYN: 'Congress number',
      SPCM_NUMBER_DYN: 'SPCM number',
      SCCQ_NUMBER_DYN: 'SCCQ number',
      PROJECTS: 'Projects',
      PROJECT: 'Project',
      CONGRESS: 'Congress',
      GROUP_ENTERPRISE: 'Group',
      CONGRESSES: 'Congresses',
      SEND_CONTRAT_BANQUET: 'Send contrat banquet',
      SPCM_NUMBER: '# SPCM',
      SCCQ_NUMBER: '# SCCQ',
      PROJECT_NUMBER: 'Project #',
      ALERT_DISTRUBITION_MODE_MAIL_ME:
        'Your request is being processed when the report is ready, it will be sent by email',
      SEND_PDF_WITH_EMAIL: 'Send report with email',

      MOVE_TO_PROJECT: 'Move to project',
      COPY_TO_PROJECT: 'Copy to project',
      GROUP_ACTION_MOVE_EVENT: 'Move events',
      GROUP_ACTION_COPY_EVENT: 'Copy events',
      EVENT_TYPE: 'Event type',
      ACTION: 'Action',
      CLONED_SUCCESSFULLY: 'Cloned successfully',
      MOVED_SUCCESSFULLY: 'Moved successfully',
      CREATE_CONGRESS_TITLE: 'Create a congress',

      CREATE_ORDER: 'Create an order',
      CREATE_PROPOSAL: 'Create a proposal',
      CREATE_INVOICE: 'Create an invoice',

      CANCEL_PROJECT_CONFIRM: 'Are you sure you want to cancel this project?',
      CANCEL_CONGRESS_CONFIRM: 'Are you sure you want to cancel this congress?',

      MAX_USER_TOO_LOW_ERROR:
        'The number of users entered is less than your number of active users.',
      USERS_COUNT: 'Current active user count',
      DISCOUNT_OR_SURCHARGE: 'Discount / Surchage',
      NO_SERVICE_CHARGE: 'No service charge for this enterprise',
      NEW_SERVICE_CHARGE: 'Create service charge',
      NEW_SERVICE_CHARGE_NAME: 'New service charge name',
      ADD_SERVICE_CHARGE: 'Add service charge',
      UPDATE_SERVICE_CHARGE: 'Update service charge',
      UPDATE: 'Update',
      CONTRAT_BANQUET: 'Banquet Contract',
      PRODUCTION_ZONE: 'Production zone',
      SELECT_PRODUCTION_ZONE: 'Select production zone',
      SHOW_CHARGED_PRICE: 'Charged price',
      GL_TOOLTIP_HINT:
        'If you use the non-taxable tips field in invoices or in your online ordering stores, the subtotal - net sale in the general ledger account report does not equal the net amount in the list of invoices and other reports of sales because it includes the amount of non-taxable tips.',
      ENTERPRISE_COPY_ADDRESS_CLIENT: 'Copy business address to clients',
      COPY_ENTERPRISE_ADDRESS_CLIENTS_CONFIRM:
        'This action will modify the addresses of all clients attached to this enterprise. Are you sure you want to proceed?',
      COPY_INTERNAL_NAME_TO_EXTERNAL: 'Copy internal Name',
      AI_TRANSLATE: 'AI Translate',
      PRODUCT_UPSALE: 'Upsale',
      SET_PRODUCT_CYCLIC_DATE: 'Cyclic menu schedule',
      CLEAR_ALL_DATES: 'Reset all',
      CLEAR_ALL_DATES_CONFIRM: 'Are you sure you want to delete all dates?',
      SEARCH_PRODUCT_DETAILED:
        'search by internal name, external name or product code',
      SEARCH_PRODUCT: 'Search for your product.',
      LEFT_LIST_LABEL: 'Drag & drop or use the + button to add product',
      RIGHT_LIST_LABEL: 'Rearrange or use the - button to remove product',
      SEARCH_PRODUCTS: 'Search products',
      TAG_INVOICE_NUMBER: 'Invoice Number',
      TAG_ORDER_NUMBER: 'Order Number',
      TAG_PROPOSAL_NUMBER: 'Proposal Number',
      TAG_EVENT_NAME: 'Event name',
      TAG_EVENT_DATE_TIME: 'Event Date and Time',
      TAG_EVENT_DATE: 'Event Date',
      TAG_EVENT_TIME: 'Event Time',
      TAG_INVOICED_ENTERPRISE_OR_CLIENT: 'Invoiced company or client',
      TAG_ORDERED_ENTERPRISE_OR_CLIENT: 'Ordering company or client',
      TAG_ORDERED_CLIENT_FULL_NAME: 'Full name of ordering client',
      TAG_INVOICED_CLIENT_FULL_NAME: 'Full name of invoiced client',
      TAG_ORDERED_CLIENT_FIRST_NAME: 'First name of ordering client',
      TAG_INVOICED_CLIENT_FIRST_NAME: 'First name of invoiced client',
      TAG_EVENT_CALENDAR_LINK: 'Event calendar link',
      TAG_PAYMENT_LINK_STRIPE: 'Stripe payment link',
      TAG_PROPOSAL_ACCEPT_LINK: 'Online acceptance button of the proposal',
      TAG_FOLLOWUP_STEP: 'Follow-up number (1, 2, 3)',
      TAG_FIRST_NAME_SENDER: 'Sender first name',
      TAG_LAST_NAME_SENDER: 'Sender last name',
      TAG_FULL_NAME_SENDER: 'Sender full name',
      TAG_ORG_NAME: 'Organization name',
      TAG_ORG_TEL: 'Organization phone',
      TAG_SELECT_LABEL: 'Dynamic data',
    },
    CLIENT_OVERRIDE: {
      'capital-traiteur': {
        GENERIC: {
          ENTERPRISES: 'Clients',
          ENTERPRISE: 'Client',
          CLIENTS: 'Contacts',
          CLIENT: 'Contact',
          CLIENT_NAME: 'Contact name',
          CREATE_CLIENT: 'Contact created successfully',
          CLIENT_INVOICE: 'Contact invoice',
          OPEN_CLIENT: 'Open contact page',
          WEB_CLIENT: 'Web contact',
          CLIENTS_ENTERPRISE: 'Contacts and enterprises',
          OPEN_ENTERPRISE: 'Open customer page',
        },
        ERRORS: {
          CREATE_CLIENT: 'An error occurred while creating the contact',
        },
        API_CALL_SUCCESS: {
          CREATE_CLIENT: 'Contact created successfully',
          CREATE_ENTERPRISE: 'Client created successfully',
        },
      },
      'agence-traiteur': {
        GENERIC: {
          ENTERPRISES: 'Clients',
          ENTERPRISE: 'Client',
          CLIENTS: 'Contacts',
          CLIENT: 'Contact',
          CLIENT_NAME: 'Contact name',
        },
      },
      CREATE_ORDER: 'Create an order',
      CREATE_PROPOSAL: 'Create a proposal',
    },
    PWA: {
      INSTALL_APP: 'Install the app',
      IOS_TITLE: 'Install the app',
      IOS_INTRO:
        'To install this app on your iPhone or iPad, follow these steps:',
      IOS_STEP_1: 'Tap the Share button (the square with an arrow).',
      IOS_STEP_2: 'Scroll down and choose "Add to Home Screen".',
      IOS_STEP_3: 'Tap "Add" to confirm.',
    },
  },
};
